<template>
      <div class="toprated">
            <h2 class="toprated-header">Netflix Toprated</h2>
           <!--   netflixtoprated  start -->
 
            <div class="netflix-trending toprated">
                <div class="leftarrow" v-on:click="leftarrow()"><img src="../images/chevron-left-solid.svg"></div>
                <div class="rightarrow" v-on:click="rightarrow()"><img src="../images/chevron-right-solid.svg"></div>
                <div class="netflix nettoprat" v-for=" (toprated,index) in netflixtoprated"  v-bind:key="index">
                    <div class="netflix-original-images">
                        <div class="netflix-original-images mediumimage">
                            <img :src="`https://image.tmdb.org/t/p/original`+`${toprated.backdrop_path}`">
                                <p> {{ toprated.original_name}} </p>
                                <div class="desc-part">
                                    <div class="icon">
                                        <img src="../images/play-solid.svg">
                                        <img src="../images/plus-circle-solid.svg">
                                        <img src="../images/thumbs-up-solid.svg">
                                        <img src="../images/thumbs-down-solid.svg">
                                    </div>
                                    <div class="desc-sec">
                                        <span class="match" style="color:green">{{toprated.vote_average}}% Match</span>
                                        <span>{{ toprated.overview }}</span>
                                    </div>
                                </div>
                            </div>
                    </div>
            </div>
            </div>
            <!--   netflixtoprated end -->
      </div>
</template>

<script>
import axios from 'axios';
const API_KEY = "c20644006c1a56f0c5eca8d53b6ccf4e";

export default {
    data(){
        return{
            netflixtoprated:[],
        }
    },
    created(){
        // trending
         axios.get(`https://api.themoviedb.org/3/movie/top_rated?api_key=${API_KEY}&language=en-US`)
            .then(toprated => {
            console.log(toprated.data.results)
            this.netflixtoprated = toprated.data.results;
            })
    }
}
</script>

<style scoped>
.netflix-origional::-webkit-scrollbar,.netflix-trending::-webkit-scrollbar{
    display: none;
}
.toprated-header{
        margin-top: -2.4vw;
        color: white;
    }
   .toprated{
       overflow: hidden;
       padding:2vw 0 21vw 0;
       margin-top: 0vw;
   }
   .netflix-trending{
      display: flex;
        flex-direction: row;
        align-items: center;
        overflow: auto;
   }
  .netflix-original-images{
       width:15vw;
       height:10vw;
       margin-left: 0.2vw;
       transform: scale(1);
   }
   .netflix{
      transition: transform .3s;
   }
   .netflix:hover{
        transform: scale(1.5);
        z-index: 5000;
   }
   .netflix-original-images p{
    top: 20%;
    position: absolute;
    transform: translateY(-20%);
        width: 100%;
    font-size: 1vw;
    text-align: center;
    font-family: 'Rock Salt', cursive;
   }
   
   
    .leftarrow,.rightarrow{
      color:white;
  }
  .leftarrow{
  z-index: 50;
     position: absolute;
    height: max-content;
    margin-top: 80px;
    width: 30px;
    visibility: hidden;
  }
  .rightarrow{
      z-index: 50;
     position: absolute; 
    right: 77px;
    margin-top: 80px;
    width: 30px;
    visibility: hidden;
  }
  .netflix-origional:hover .leftarrow,
  .netflix-origional:hover .rightarrow{
   visibility: visible;
  }
  
 .netflix-original-images img{
        height: 100%;
        width: 100%;
        object-fit: contain;
        object-position: center;
       }
       .nettoprat:hover .desc-part{
          visibility: visible;
       }
.desc-part{
    color: white;
    height:auto;
    background-color:black;
    visibility: hidden;
    z-index: -10;
    transition: 0.1s ease-in;
    margin-top: -1.5vw;
  }
  .desc-part .icon{
   padding: 20px;
   overflow: hidden;
   display: flex;

  }
  .desc-part .icon img{
      height: 1vw;
      width: 1vw;
      border:1px solid white;
      border-radius: 50%;
      padding: 0.5vw;
      margin-left: 10px;
  }
  .desc-sec{
      padding: 0 1vw 1vw 1vw;
  }
  .desc-sec span{
      font-size: 10px;
      color: white;
      margin-top: 0vw;
  }
  .match{
      color:green;
      display: block;
      font-weight: 700;
  }
</style>